export enum EConceitoPrecificacao {
    PrecoPadrao = 1,
    TabelaPrecoPorCliente = 2,
    TabelaPrecoPorCidade = 3,
    TabelaPrecoPorEstado = 4,
    TabelaPrecoPorRegiao = 5,
}
